/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Badge, ListItemButton, Typography } from "@mui/material";
import { Link, useLocation } from "react-router";
import { EmailOutlined } from "@mui/icons-material";
import { mergeSx } from "@/src/utils/mergeSx";
import { authenticatedNavigationStyle } from "@/src/components/AuthenticatedNavigation/authenticatedNavigationStyle";
import { useBasicAccountData } from "@/src/provider/BasicAccountData/BasicAccountDataProvider";

export type AuthenticatedNavigationLinkMessagesProps = {
  iconColor?: string;
};

export default function AuthenticatedNavigationLinkMessages({ iconColor }: AuthenticatedNavigationLinkMessagesProps) {
  const location = useLocation();
  const { newMessages } = useBasicAccountData();

  const linkPath = "/servicewelt/nachrichten";

  return (
    <ListItemButton
      component={Link}
      to={linkPath}
      sx={mergeSx(authenticatedNavigationStyle.link, location.pathname === linkPath && authenticatedNavigationStyle.linkActive, { margin: "0.25rem 0" })}
    >
      <Badge color={"warning"} badgeContent={newMessages?.length} sx={{ marginRight: "1.25rem" }}>
        <EmailOutlined sx={{ color: iconColor }} />
      </Badge>
      <Typography component={"span"} variant={"cardTitle"}>
        Nachrichten
      </Typography>
    </ListItemButton>
  );
}
